/**
 * LightShell — shared entry-experience wrapper (Welcome, Sign In, Create
 * Account, Waitlist landing). Bright white surface, prominent Link
 * wordmark, generous spacing — matches the rider Account / Checkout
 * Plan / Confirmation aesthetic so the brand reads as one product.
 *
 * Replaces the dark `LinkCityScene` cinematic background everywhere
 * outside the rider map.
 */
import React from "react";

export default function LightShell({ children, contentClassName = "", testId = "light-shell" }) {
  return (
    <div
      className="min-h-[100dvh] bg-[#F9F7F4] text-[#0A1128] flex flex-col"
      data-testid={testId}
    >
      <header
        className="pt-[max(env(safe-area-inset-top),16px)] pb-2 flex justify-center"
        data-testid={`${testId}-header`}
      >
        <img
          src="/assets/link-full-logo.svg?v=13"
          alt="Link"
          // Compact wordmark — keeps the header from dominating the
          // page on smaller viewports. Was h-12/sm:h-14 (too tall).
          className="h-9 sm:h-10 w-auto"
          data-testid={`${testId}-logo`}
        />
      </header>
      <main className={`flex-1 w-full max-w-xl mx-auto px-6 sm:px-8 pb-12 ${contentClassName}`}>
        {children}
      </main>
    </div>
  );
}

/**
 * RouteIllustration — simple Home ●──────● Destination visual. Replaces
 * skyline imagery. Pure SVG, no stock photos, no themes.
 */
export function RouteIllustration({ origin = "Home", destination = "Work", testId = "route-illustration" }) {
  return (
    <div
      className="rounded-3xl bg-white border border-black/[0.06] shadow-sm px-6 py-7 space-y-4"
      data-testid={testId}
    >
      <div className="flex items-center gap-3">
        <span className="w-3 h-3 rounded-full bg-[#0074d4] shrink-0" aria-hidden="true" />
        <span className="text-[14px] font-semibold tracking-wide text-[#0A1128]">{origin}</span>
        <div className="flex-1 h-[2px] rounded-full bg-gradient-to-r from-[#0074d4] via-[#ed6500] to-[#ed6500]" aria-hidden="true" />
        <span className="text-[14px] font-semibold tracking-wide text-[#0A1128]">{destination}</span>
        <span className="w-3 h-3 rounded-full bg-[#ed6500] shrink-0" aria-hidden="true" />
      </div>
      <div className="flex items-center justify-between text-[11px] tracking-[0.22em] uppercase text-[#515E7B] pt-2 border-t border-black/[0.05]">
        <span>Mon · Tue · Wed · Thu · Fri</span>
        <span className="text-[#ed6500] font-semibold">Pickup + return</span>
      </div>
    </div>
  );
}
